export default "__VITE_ASSET__uxYtK5TQ__"